import { TaskCreationSourceKind } from "./IGraphTaskCreationResource";
/**
 * Checks if the given resource is a GraphExternalTaskSourceResource
 * @param resource The resource to check
 * @returns True if the resource is a GraphExternalTaskSourceResource
 */ export function isGraphExternalTaskSourceResource(resource) {
    return resource.creationSourceKind === TaskCreationSourceKind.External;
}
